module.exports = __webpack_public_path__ + "static/media/logo-roomburgh.708222dd.png";